import { scrollTo } from '../common/utils';

const initialize = () => {
    $('a[href^="#"]')
        .not('[href^="#/"]')
        .click(function(event) {

            event.preventDefault();

            const hash = this.hash;

            if (hash.length === 0) {

                return;
            } else if ($(hash).length === 0) {

                log.error(`Could not find element "${hash}".`);
                return;
            }

            scrollTo($(hash));
        });
};

export default {
    initialize,
};

